import * as _ from 'lodash';
import {CHANGE_REQUESTED_DATA_VALIDITY} from '../actions/types';
import {dataIsValidAffectedIds, dataIsValidAfterDelete, dataIsValidAfterSave, dataValidityKey} from '../constants';

const defaultResourceValidityValue = {[dataIsValidAfterDelete]: true, [dataIsValidAfterSave]: true, [dataIsValidAffectedIds]: []};

export const realtimeReducer = (state = {}, {type, resource, payload}) => {
  if (type === CHANGE_REQUESTED_DATA_VALIDITY) {
    const oldValue = _.get(state, [resource, dataValidityKey], defaultResourceValidityValue);
    const newState = {...state};
    _.set(newState, [resource, dataValidityKey], {...oldValue, ...payload});
    return newState;
  }

  return state;
};